"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[362],{

/***/ 71800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_Button; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/components/atoms/Button/styled.tsx


var ButtonContainer = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__ButtonContainer",
  componentId: "sc-nqd5s5-0"
})(["display:grid;place-content:center;padding:6px 12px;background-color:", ";color:", ";border:none;cursor:pointer;&:hover{background:", ";}", " ", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return props.backgroundColor ? props.backgroundColor : props.theme.colors.theme.primary["default"];
}, function (props) {
  return props.theme.colors.text.white;
}, function (props) {
  return props.hoverBackgroundColor ? props.hoverBackgroundColor : props.theme.colors.theme.primary.dark;
}, function (props) {
  return props.disabled ? (0,styled_components_browser_esm/* css */.iv)(["pointer-events:none;background:", ";"], function (props) {
    return props.theme.colors.theme.primary.soft;
  }) : null;
}, function (props) {
  return props.variant === 'outline' ? (0,styled_components_browser_esm/* css */.iv)(["background-color:transparent;color:", ";border:2px solid #e9ecef;&:hover{background-color:transparent;color:", ";}"], function (props) {
    return props.theme.colors.text["default"];
  }, function (props) {
    return props.theme.colors.text.primary;
  }) : null;
}, function (props) {
  return props.disabled && props.variant === 'outline' ? (0,styled_components_browser_esm/* css */.iv)(["pointer-events:none;opacity:0.3;"]) : null;
}, function (props) {
  return props.variant === 'subtle' ? (0,styled_components_browser_esm/* css */.iv)(["background-color:transparent;color:", ";border:none;&:hover{background:", ";}"], function (props) {
    return props.theme.colors.text["default"];
  }, function (props) {
    return props.theme.colors.theme.neutralLight["default"];
  }) : null;
}, function (props) {
  return props.disabled && props.variant === 'subtle' ? (0,styled_components_browser_esm/* css */.iv)(["pointer-events:none;opacity:0.3;"]) : null;
}, function (props) {
  return props.variant === 'link' ? (0,styled_components_browser_esm/* css */.iv)(["padding:0;height:revert !important;background-color:transparent;color:", ";border:none;&:hover{background-color:transparent;text-decoration:underline;}"], function (props) {
    return props.theme.colors.text.primary;
  }) : null;
}, function (props) {
  return props.disabled && props.variant === 'link' ? (0,styled_components_browser_esm/* css */.iv)(["pointer-events:none;opacity:0.3;"]) : null;
}, function (props) {
  return props.block ? (0,styled_components_browser_esm/* css */.iv)(["width:100% !important;"]) : null;
});
var ButtonText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "styled__ButtonText",
  componentId: "sc-nqd5s5-1"
})(["cursor:pointer;margin:0;font-weight:700;font-size:14px;font-family:'PT Sans',sans-serif;", " ", ";user-select:none;-webkit-user-select:none;-moz-user-select:none;-khtml-user-select:none;-ms-user-select:none;"], function (props) {
  return props.size === 'xs' || props.size === 'sm' ? (0,styled_components_browser_esm/* css */.iv)(["font-size:14px;"]) : null;
}, function (props) {
  return props.size === 'md' || props.size === 'lg' ? (0,styled_components_browser_esm/* css */.iv)(["font-size:16px;"]) : null;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/atoms/Button/index.tsx


var _excluded = ["type", "onClick", "size", "disabled", "children", "variant", "block"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 //function that  take any number of arguments of any type and return a value of any type.


//In order to have code completion on the keys here, we create a Record<T,K> type referenced in /types/buttonStyle.ts
var buttonStyles = {
  xs: {
    height: 32,
    width: 'fit-content'
  },
  sm: {
    height: 40,
    width: 'fit-content'
  },
  md: {
    height: 48,
    width: 'fit-content'
  },
  lg: {
    height: 56,
    width: 'fit-content'
  }
};
/**
 *  Button Component with custom sizes and variants
 *
 */

var Button = function Button(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      onClick = props.onClick,
      size = props.size,
      disabled = props.disabled,
      children = props.children,
      variant = props.variant,
      block = props.block,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonContainer, _objectSpread(_objectSpread({
    type: type,
    onClick: onClick,
    style: buttonStyles[size],
    variant: variant,
    disabled: disabled,
    block: block,
    backgroundColor: props.backgroundColor,
    hoverBackgroundColor: props.hoverBackgroundColor
  }, rest), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonText, {
      size: size,
      children: children
    })
  }));
};

/* harmony default export */ var atoms_Button = (Button);

/***/ }),

/***/ 74398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ textInputHeights; }
/* harmony export */ });
/* harmony import */ var _Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16835);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82580);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25018);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var textInputHeights = {
  sm: {
    container: {
      height: 40
    }
  },
  md: {
    container: {
      height: 48
    }
  },
  lg: {
    container: {
      height: 56
    }
  }
};

var TextInput = function TextInput(props) {
  var _props$type, _props$paddingLeft, _props$paddingRight;

  var fieldProps;

  if (!props.withoutFormik) {
    var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_1__/* .useField */ .U$)(props.name),
        _useField2 = (0,_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useField, 3),
        field = _useField2[0],
        meta = _useField2[1],
        helpers = _useField2[2];

    fieldProps = field;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .TextInputContainer */ .ai, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .FieldWrapper */ .n2, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledField */ .ob, _objectSpread(_objectSpread({}, fieldProps), {}, {
        disabled: props.disabled,
        onChange: function onChange(e) {
          if (fieldProps) {
            fieldProps.onChange(e);
          } else if (props.onChange) {
            props.onChange(e.target.value);
          }
        },
        defaultValue: props.defaultValue,
        "data-testid": "field-".concat(props.name),
        name: props.name,
        placeholder: props.placeholder,
        type: (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'text',
        isError: props.errorMessage ? true : false,
        style: _objectSpread({
          height: textInputHeights[props.size].container.height - 1,
          paddingLeft: (_props$paddingLeft = props.paddingLeft) !== null && _props$paddingLeft !== void 0 ? _props$paddingLeft : 30,
          paddingRight: (_props$paddingRight = props.paddingRight) !== null && _props$paddingRight !== void 0 ? _props$paddingRight : 30
        }, props.styles)
      }))
    }), props.errorMessage ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledErrorMessage */ .Vv, {
      children: props.errorMessage
    }) : null]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (TextInput);

/***/ }),

/***/ 25018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vv": function() { return /* binding */ StyledErrorMessage; },
/* harmony export */   "ai": function() { return /* binding */ TextInputContainer; },
/* harmony export */   "n2": function() { return /* binding */ FieldWrapper; },
/* harmony export */   "ob": function() { return /* binding */ StyledField; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14141);
/* harmony import */ var _Fonts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73648);


var TextInputContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "styled__TextInputContainer",
  componentId: "sc-134ads-0"
})(["display:flex;flex-direction:column;width:100%;"]);
var StyledField = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input.withConfig */ .ZP.input.withConfig({
  displayName: "styled__StyledField",
  componentId: "sc-134ads-1"
})(["flex:1 1;border:solid 1px #ccc;:focus{outline:none;}font-family:'PT Sans';width:100%;"]);
var StyledErrorMessage = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Fonts__WEBPACK_IMPORTED_MODULE_0__/* .SubTitle */ .DK).withConfig({
  displayName: "styled__StyledErrorMessage",
  componentId: "sc-134ads-2"
})(["color:", ";margin-top:8px;"], function (props) {
  return props.theme.colors.text.danger;
});
var FieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "styled__FieldWrapper",
  componentId: "sc-134ads-3"
})(["display:flex;width:100%;position:relative;"]);

/***/ }),

/***/ 21520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14141);
/* harmony import */ var _styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15143);


var SideBannerContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SideBannerContentContainer",
  componentId: "sc-jmyngt-0"
})(["flex:1 0 500px;height:100%;display:flex;overflow-y:auto;@media ", "{flex:1;overflow-y:initial;}"], _styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .device.mobile */ .U.mobile);
/* harmony default export */ __webpack_exports__["Z"] = (SideBannerContentContainer);

/***/ }),

/***/ 96949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* reexport */ containers_SideBannerContainer; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./src/styles/breakpoints/index.ts
var breakpoints = __webpack_require__(15143);
;// CONCATENATED MODULE: ./src/components/containers/SideBannerContainer.tsx


var SideBannerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SideBannerContainer",
  componentId: "sc-1p5colx-0"
})(["background-size:cover;background-position:left;flex:0 1 ", "px;height:100%;display:flex;align-items:center;justify-content:center;@media ", "{display:none;}"], function (props) {
  return props.maxImageWidth;
}, breakpoints/* device.laptop */.U.laptop);
/* harmony default export */ var containers_SideBannerContainer = (SideBannerContainer);
;// CONCATENATED MODULE: ./src/components/containers/index.tsx
/*Common containers that have styles used across the app*/



/***/ }),

/***/ 95259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ molecules_LogoWithTitle; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./src/components/atoms/Fonts/index.tsx
var Fonts = __webpack_require__(73648);
;// CONCATENATED MODULE: ./src/components/molecules/LogoWithTitle/styled.tsx


var LogoWithTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__LogoWithTitleContainer",
  componentId: "sc-8pwjue-0"
})(["display:flex;flex-direction:column;align-items:center;"]);
var LogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__LogoWrapper",
  componentId: "sc-8pwjue-1"
})(["margin-bottom:40px;"]);
var Title = (0,styled_components_browser_esm/* default */.ZP)(Fonts/* Header2 */.zV).withConfig({
  displayName: "styled__Title",
  componentId: "sc-8pwjue-2"
})(["color:", ";"], function (props) {
  return props.theme.colors.text.dark;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/molecules/LogoWithTitle/index.tsx
 // import logo from '/public/assets/images/logo/logo.png';




var LogoWithTitle = function LogoWithTitle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LogoWithTitleContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, {
      style: props.gap ? {
        marginBottom: props.gap
      } : {},
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: 'https://public.dealerportal.eyeforce.com/logo.png',
        alt: "Eyeforce",
        style: {
          width: 'auto',
          height: 50
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: props.title
    })]
  });
};

/* harmony default export */ var molecules_LogoWithTitle = (LogoWithTitle);

/***/ }),

/***/ 19017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ molecules_TextFieldWithIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./src/components/atoms/Icon/index.tsx + 38 modules
var Icon = __webpack_require__(34876);
// EXTERNAL MODULE: ./src/components/atoms/TextInput/index.tsx
var TextInput = __webpack_require__(74398);
;// CONCATENATED MODULE: ./src/components/molecules/TextFieldWithIcon/TextFieldWithIcon.styled.tsx

var TextFieldWithIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TextFieldWithIconstyled__TextFieldWithIconContainer",
  componentId: "sc-17herdd-0"
})(["display:flex;position:relative;"]);
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TextFieldWithIconstyled__IconWrapper",
  componentId: "sc-17herdd-1"
})(["position:absolute;z-index:200;display:flex;align-items:center;", ";", ";cursor:", ";"], function (props) {
  return props.iconSide === 'left' ? " left: 16px" : null;
}, function (props) {
  return props.iconSide === 'right' ? " right: 16px" : null;
}, function (props) {
  return props.onClick ? 'pointer' : 'default';
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/molecules/TextFieldWithIcon/TextFieldWithIcon.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var styles = {
  sm: {
    icon: {
      width: 16,
      height: 16
    }
  },
  md: {
    icon: {
      width: 24,
      height: 24
    }
  },
  lg: {
    icon: {
      width: 24,
      height: 24
    }
  }
};

var TextFieldWithIcon = function TextFieldWithIcon(props) {
  var _props$type, _props$withIconFill, _props$withIconFill2;

  var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
  var textFieldProps = {
    name: props.name,
    withoutFormik: props.withoutFormik,
    size: props.size,
    placeholder: props.placeholder,
    paddingRight: props.withIconSide === 'right' ? styles[props.size].icon.width + (30 + 16) : 30,
    paddingLeft: props.withIconSide === 'left' ? styles[props.size].icon.width + (30 + 16) : 30,
    errorMessage: props.errorMessage,
    type: (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'text',
    onChange: props.onChange,
    defaultValue: props.defaultValue
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TextFieldWithIconContainer, {
    children: [props.withIcon && props.withIconSide == 'right' ? /*#__PURE__*/(0,jsx_runtime.jsx)(IconWrapper, {
      iconSide: "right",
      onClick: props.onIconClick //match the height of the text input so the icon can be centered vertically
      ,
      style: {
        height: TextInput/* textInputHeights */._[props.size].container.height
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
        name: props.withIcon,
        size: styles[props.size].icon.width,
        color: (_props$withIconFill = props.withIconFill) !== null && _props$withIconFill !== void 0 ? _props$withIconFill : theme.colors.text.light
      })
    }) : null, props.withoutFormik ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, _objectSpread({}, textFieldProps)) : /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
      name: props.name,
      children: function children(field) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, _objectSpread(_objectSpread({}, textFieldProps), {}, {
          disabled: props.disabled
        }));
      }
    }), props.withIcon && props.withIconSide == 'left' ? /*#__PURE__*/(0,jsx_runtime.jsx)(IconWrapper, {
      iconSide: "left",
      onClick: props.onIconClick //match the height of the text input so the icon can be centered vertically
      ,
      style: {
        height: TextInput/* textInputHeights */._[props.size].container.height
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
        name: props.withIcon,
        iconProps: styles[props.size].icon,
        size: styles[props.size].icon.width,
        color: (_props$withIconFill2 = props.withIconFill) !== null && _props$withIconFill2 !== void 0 ? _props$withIconFill2 : theme.colors.text.light
      })
    }) : null]
  });
};

/* harmony default export */ var TextFieldWithIcon_TextFieldWithIcon = (TextFieldWithIcon);
;// CONCATENATED MODULE: ./src/components/molecules/TextFieldWithIcon/index.tsx

/* harmony default export */ var molecules_TextFieldWithIcon = (TextFieldWithIcon_TextFieldWithIcon);

/***/ }),

/***/ 60988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PasswordField_PasswordField; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./src/components/molecules/TextFieldWithIcon/index.tsx + 2 modules
var TextFieldWithIcon = __webpack_require__(19017);
;// CONCATENATED MODULE: ./src/components/organisms/PasswordField/PasswordField.styled.tsx

var PasswordFieldContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PasswordFieldstyled__PasswordFieldContainer",
  componentId: "sc-oj38po-0"
})(["display:flex;flex-direction:column;flex:1;"]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/organisms/PasswordField/PasswordField.tsx






var PasswordField = function PasswordField(props) {
  var _useState = (0,react.useState)(false),
      enabled = _useState[0],
      setEnabled = _useState[1];

  var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordFieldContainer, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextFieldWithIcon/* default */.Z, {
      name: props.name,
      size: props.size,
      placeholder: props.placeholder,
      onIconClick: function onIconClick() {
        return props.onIconClick ? props.onIconClick() : setEnabled(!enabled);
      },
      type: enabled || props.isEnabled ? 'text' : 'password',
      withIcon: "eye",
      withIconSide: "right",
      withIconFill: props.isEnabled || enabled ? theme.colors.text.primary : theme.colors.text.light,
      errorMessage: props.errorMessage
    })
  });
};

/* harmony default export */ var PasswordField_PasswordField = (PasswordField);

/***/ }),

/***/ 77730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ api; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70594);

var api = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
api.defaults.baseURL = "https://api.dealerportal.eyeforce.com";
api.defaults.withCredentials = true;

/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 16835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ })

}]);